import PaymentFormComp from './payment-form.vue';
export default PaymentFormComp;
